<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-timer"></i> 视频在线时长
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-select v-model="query.valueSBASAAI" clearable filterable :placeholder="'请选择所属幼儿园'"
									class="handle-select mr10" style="width: 15%;">
									<el-option v-for="item in query.optionsSBASAAI" :key="item.SAAMSID"
										:label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
								<el-input v-model="query.parentTel" clearable :placeholder="'请输入家长电话号'"
									class="handle-input mr10" style="width: 15%;"></el-input>
								<el-input v-model="query.childName" clearable :placeholder="'请输入宝宝名称'"
									class="handle-input mr10" style="width: 15%;"></el-input>

								<el-input v-model="query.name" clearable :placeholder="'请输入视频名称'"
									class="handle-input mr10" style="width: 15%;"></el-input>
								<el-date-picker v-model="query.start" type="datetime" :picker-options="starttime"
									value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
									style="width: 14%;margin-right: 0.8%;" :placeholder="'登入时间'" />
								<span style="margin-right: 0.8%;">-</span>
								<el-date-picker v-model="query.end" type="datetime" :picker-options="endTime"
									value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width: 14%;"
									:placeholder="'登出时间'" />
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float"
									icon="el-icon-search" @click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.exportPerms)"
									icon="el-icon-download" @click="tableToExcel">导出Excel</el-button>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
							</div>
						</el-col>
					</el-row>
				</div>
				<el-table ref="datalist" :data="tableData" border class="table"
					:default-sort="{prop: 'CBBINDT', order: 'descending'}" header-cell-class-name="table-header"
					@selection-change="handleSelectionChange" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="selection" :reserve-selection="true" align="center" width="50">
					</el-table-column>
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="SAANAME" :label="'所属幼儿园'" align="center"></el-table-column>
					<el-table-column prop="CBBMSID" :label="'ID'" align="center" v-if='show' width="150">
					</el-table-column>
					<el-table-column prop="HAAPHON" :label="'手机号'" align="center"></el-table-column>
					<el-table-column prop="HABNAME" :label="'宝宝名称'" align="center"></el-table-column>
					<el-table-column prop="CAANAME" :label="'视频名称'" align="center"></el-table-column>
					<el-table-column prop="CBBDLDT" :label="'登入时间'" align="center"></el-table-column>
					<el-table-column prop="CBBOVDT" :label="'登出时间'" align="center"></el-table-column>
					<el-table-column prop="CBBTIME" :label="'在线时长'" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper"
						:current-page="this.query.pageIndex" :page-size="this.query.pageSize" :total="this.pageTotal"
						@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'monitorCBBList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					searchPerms: 'monitorCBB:monitorCBBList:search', //搜索权限标识
					exportPerms: 'monitorCBB:monitorCBBList:export', //导出权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户

				// 开始时间
				starttime: {
					disabledDate: time => {
						if (this.query.end) {
							return (
								time.getTime() > new Date(this.query.end).getTime()
							)
						} else {
							// 不能大于当前日期
							return time.getTime() > Date.now()
						}
					}
				},
				// 结束时间
				endTime: {
					disabledDate: time => {
						if (this.query.start) {
							return (
								time.getTime() > Date.now() ||
								time.getTime() < new Date(this.query.start).getTime() - 8.64e6
							)
						} else {
							return time.getTime() > Date.now()
						}
					}
				},

				query: {
					parentTel: '', //家长电话号
					childName: '', //宝宝名称
					valueSBASAAI: '', //幼儿园名称
					optionsSBASAAI: '',
					name: '', //视频名称 
					start: new Date(new Date(new Date().toLocaleDateString()).getTime()), //登入时间
					end: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1), //登出时间
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				pageTotal: 0, // 总条数
				loading: false

			};
		},
		created() {
			let curpagenum = this.query.pageIndex; //当前页码
			this.show = false;

			this.getSAA(); //获取幼儿园信息

			this.getData(curpagenum); //获取当前列表数据
			this.get_CBB_List_Count(); //获取当前列表条数
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//时间格式化
			dateFormat: function(val) {
				var t = new Date(val); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate(),
					hour = t.getHours(),
					min = t.getMinutes();
				var newTime = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day) + ' ' +
					(hour < 10 ? '0' + hour : hour) + ':' +
					(min < 10 ? '0' + min : min);
				return newTime;
			},
			//获取幼儿园信息
			getSAA() {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsSBASAAI = response.data.KKDT;
							response.data.KKDT.forEach((team, index) => {
								this.query.optionsSBASAAI[index].SAANAME = team.SAANAME;
								this.query.optionsSBASAAI[index].SAAMSID = team.SAAMSID;
							})
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取幼儿园信息请求失败', //请求失败
							type: 'error'
						});
					});
			},
			// 获取当前列表条数
			get_CBB_List_Count() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcCBB.svc/Get_CBB_List_Count';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sHAAPHON: self_count.query.parentTel.trim(),
							sHABNAME: self_count.query.childName.trim(),
							sSAAI: self_count.query.valueSBASAAI,
							sTITL: self_count.query.name.trim(),
							sSTARTDATE: this.dateFormat(self_count.query.start),
							sENDDATE: this.dateFormat(self_count.query.end),
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						this.pageTotal = Number(resCount); //总条数
					})
					.catch((error) => {
						this.$message({
							message: '获取视频在线时长失败', //请求失败
							type: 'error'
						});
					});
			},
			// 获取视频在线时长数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcCBB.svc/Get_CBB_List';
				//debugger;

				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sHAAPHON: self_count.query.parentTel.trim(),
							sHABNAME: self_count.query.childName.trim(),
							sSAAI: self_count.query.valueSBASAAI,
							sTITL: self_count.query.name.trim(),
							sSTARTDATE: this.dateFormat(self_count.query.start),
							sENDDATE: this.dateFormat(self_count.query.end),
							sPageIndex: curpage, //页码
							sPageSize: self_count.query.pageSize //每页显示条数	
						})
					.then((response) => {
						this.loading = false; //取消loading效果
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						let resKKDT = response.data.KKDT;
						if (resCount > 0) {
							//渲染数据 List
							this.tableData = resKKDT; //数据数组
							//console.log(resKKDT);
						} else {
							this.tableData = []; //数据数组
						}
					})
					.catch((error) => {
						this.loading = false; //取消loading效果
						this.$message({
							message: '获取视频在线时长失败', //请求失败
							type: 'error'
						});
					});

			},
			// 触发搜索按钮
			handleSearch() {

				let sSTARTDATE = this.query.start;
				let sENDDATE = this.query.end;

				if (sSTARTDATE === null && sENDDATE !== null) {
					this.$alert('请选择登入时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});

					return false;
				} else if (sSTARTDATE !== null && sENDDATE === null) {
					this.$alert('请选择登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});

					return false;
				} else if (sSTARTDATE === null && sENDDATE === null) {
					this.$alert('请选择登入时间和登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});

					return false;
				}

				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.get_CBB_List_Count(); //获取当前列表条数

				this.multipleSelection = []
				this.$refs.datalist.clearSelection(); //清空列表多选框

			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(size);
			},
			// 导出
			tableToExcel() {

				const length = this.multipleSelection.length;
				//console.log(this.multipleSelection)

				if (length > 0) {
					this.$confirm('此操作将导出excel文件, 是否继续?', '提示', {
						confirmButtonText: '确定', //确定
						cancelButtonText: '取消', //取消
						type: 'warning'
					}).then(() => {
						if (this.multipleSelection == "") {
							this.excelData = this.tableData //你要导出的数据list。 tableData
						} else {
							this.excelData = this.multipleSelection //你要导出的数据list。 multipleSelection
						}
						//this.export2Excel()
						this.export2ExcelStyle()
					}).catch(() => {
						console.log('cancel'); //取消
					});
				} else {
					this.$confirm('请勾选要导出的数据', {
							type: 'warning'
						})
						.then(() => {})
						.catch(() => {});
				}
			},
			export2Excel() {

				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('../../vendor/Export2Excel'); //这里必须使用绝对路径
					const tHeader = ['所属幼儿园', '手机号', '宝宝名称', '视频名称', '登入时间', '登出时间', '在线时长']; // 导出的表头名
					const filterVal = ['SAANAME', 'HAAPHON', 'HABNAME', 'CAANAME', 'CBBDLDT', 'CBBOVDT',
					'CBBTIME']; // 导出的表头字段名
					const list = this.excelData;
					const data = this.formatJson(filterVal, list);
					export_json_to_excel(tHeader, data, '视频在线时长'); // 导出的表格名称，根据需要自己命名					
				})
			},

			export2ExcelStyle() {
				import('@/vendor/Export2ExcelStyle').then(excel => {

					const tHeader = ['所属幼儿园', '手机号', '宝宝名称', '视频名称', '登入时间', '登出时间', '在线时长']; // 导出的表头名
					const filterVal = ['SAANAME', 'HAAPHON', 'HABNAME', 'CAANAME', 'CBBDLDT', 'CBBOVDT',
					'CBBTIME']; // 导出的表头字段名

					const list = this.excelData.sort(this.sortNumber('CBBMSID'))
					const data = this.formatJson(filterVal, list)

					data.map(item => {
						// console.log(item)
						item.map((i, index) => {
							if (!i) {
								item[index] = ''
							}
						})
					})

					excel.export_json_to_excel({
						titleName: "视频在线时长报表",
						header: tHeader,
						data,
						border: true,
						filename: "视频在线时长", //班级名
						autoWidth: true,
						bookType: 'xlsx'
					})

				})
			},
			/** 数组排序
			 *@param prop 属性字段
			 *@returns 排序后的数组 {Array}
			 */
			sortNumber(prop) {
				return function(obj1, obj2) {
					var val1 = obj1[prop];
					var val2 = obj2[prop];
					if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
						val1 = Number(val1);
						val2 = Number(val2);
					}
					if (val1 < val2) { //降序排列
						return 1;
					} else if (val1 > val2) {
						return -1;
					} else {
						return 0;
					}
				};
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			getRowKeys(row) {
				return row.CBBMSID; // id为列表数据的唯一标识
			}
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 220px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
